import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { AddNewAddendumForm } from '../forms'
import { useHistory } from 'react-router-dom'
import * as apiActions from 'api-actions'
import { selectors } from '../reducer'
import { selectors as productSelectors } from '../../products/reducer'
import * as actions from '../actions'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Path, AccountAudience } from 'config/portal'
import { FlowActions } from '../components'
import { selectors as globalSelectors } from 'global-reducer'
import { Notification } from 'components'
import { Variant as NotificationVariant } from 'components/Notification'

const propTypes = {
  notificationsAgreements: PropTypes.arrayOf(Types.servicesAgreementSummary),
  fetchNotificationsAgreements: PropTypes.func.isRequired,
  addendumServicesAgreementHash: PropTypes.object,
  setAddendumServicesAgreementHash: PropTypes.func.isRequired,
  currentUser: Types.user.isRequired,
}

const defaultProps = {
  addendumServicesAgreementHash: null,
  notificationsAgreements: null,
}

function AddNewAddendumView({
  fetchNotificationsAgreements,
  notificationsAgreements,
  addendumServicesAgreementHash,
  setAddendumServicesAgreementHash,
  currentUser,
}) {
  useEffect(() => {
    fetchNotificationsAgreements()
  }, [])

  const history = useHistory()
  const isPlanFiduciary =
    currentUser.accountAudience === AccountAudience.PLAN_FIDUCIARY
  const servicesAgreementOptions = notificationsAgreements?.map(
    (servicesAgreement) => ({
      value: servicesAgreement.serviceAgreementID,
      label: servicesAgreement.name,
    })
  )

  const [newAddendumServicesAgreement, setNewAddendumServicesAgreement] =
    useState('')

  const [agreementErrorState, setAgreementErrorState] = useState(false)

  const initialValues =
    servicesAgreementOptions || addendumServicesAgreementHash

  const handleSubmit = () => {
    if (newAddendumServicesAgreement !== '') {
      setAddendumServicesAgreementHash(newAddendumServicesAgreement)
      setAgreementErrorState(false)
      history.push({
        pathname: isPlanFiduciary
          ? Path.REVIEW_AND_SUBMIT_NOTIFICATIONS_ADDENDUM
          : Path.REVIEW_PLAN_INFORMATION,
        state: {
          search: history.location.state?.search,
        },
      })
    } else {
      setAgreementErrorState(true)
    }
  }

  const handleAddPlanAgreementAction = () =>
    history.push({
      pathname: Path.ADD_NEW_SERVICES_AGREEMENT,
    })

  return (
    <div className="card full-height complete-services-agreement-view">
      <div className="complete-services-agreement-form-container">
        <div className="form-masthead">
          <h2>Start by selecting a services agreement</h2>
        </div>
        <p className="form-masthead-text">
          Choose the services agreement you’d like to add a notification
          services addendum to. Keep in mind, you can only add addendums to
          services agreements that have been completed and approved.
        </p>
        <Notification type={NotificationVariant.WARNING}>
          <p className="text-title--small">
            You can only start an notification services addendum if no other
            addendums are in progress.
          </p>
        </Notification>
        <div className="form-section">
          {initialValues && (
            <AddNewAddendumForm
              initialValues={initialValues}
              onSubmit={handleSubmit}
              setNewAddendumServicesAgreement={setNewAddendumServicesAgreement}
              agreementErrorState={agreementErrorState}
            />
          )}
        </div>
        <div className="addendum-new-agreement-section">
          <div className="addendum-new-agreement-text">
            Haven’t created a services agreement yet?
          </div>
          <div
            onClick={() => handleAddPlanAgreementAction()}
            className="addendum-new-agreement-link"
          >
            Get started.
          </div>
        </div>
        <FlowActions handleSubmit={handleSubmit} preventBack />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    addendumServicesAgreementHash:
      selectors.addendumServicesAgreementHash(state),
    servicesAgreements: productSelectors.servicesAgreements(state),
    shouldTriggerAllServicesAgreementsFetch:
      productSelectors.shouldTriggerAllServicesAgreementsFetch(state),
    currentUser: globalSelectors.currentUser(state),
    notificationsAgreements: selectors.notificationsAgreements(state),
  }
}

const mapDispatchToProps = {
  setCompleteServicesAgreementForm: actions.setCompleteServicesAgreementForm,
  resetErisapediaSearches: actions.resetErisapediaSearches,
  setAddendumServicesAgreementHash: actions.setAddendumServicesAgreementHash,
  fetchNotificationsAgreements: apiActions.fetchNotificationsAgreements,
}

AddNewAddendumView.propTypes = propTypes
AddNewAddendumView.defaultProps = defaultProps

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AddNewAddendumView
)
